window.addEventListener('DOMContentLoaded', (event) => {
    window.onscroll = function () {
        let currentScrollPos = window.pageYOffset;
        if (currentScrollPos > 800) {
            $('#clients').addClass('clients__items_open');
        } else {
            $('#clients').removeClass('clients__items_open');
        }
    };
});
